<template>
  <div class="content content_in">
    <div class="title-row row justify-content-between">
      <div class="col-12 col-md-auto">
        <h1>{{ $t("platform.create_new") }}</h1>
      </div>
    </div>
    <div class="sep _h10"></div>
    <div class="kinds">
      <div v-for="el in categories" :key="el" class="section kind" :style="{ gridRow: `span ${rows.length + 2}` }">
        <div class="kind__head">
          <h2>{{ $t(`platform.choose.${el}.title`) }}</h2>
          <p>{{ $t(`platform.choose.${el}.fits`) }}</p>
        </div>
        <div v-for="row in rows" :key="row" class="kind__row">
          <span class="kind__label">{{ $t(`platform.choose.rows.${row}`) }}</span>
          <div class="kind__value">
            <svg v-if="pros[el].includes(row)" v-svg symbol="check" size="0 0 17 17" role="presentation" />
            <span v-else class="kind__dash" aria-hidden="true">–</span>
            <span>{{ $t(`platform.choose.${el}.${row}`) }}</span>
          </div>
        </div>
        <div class="kind__action">
          <router-link :to="`/create-platform/${el}${el !== 'arbitrage' ? '/1' : ''}`" class="btn w-100" :class="{ '_bg-green': el !== 'arbitrage' }">
            {{ $t(`platform.${el}.create`) }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// The kinds of platforms side by side, like the plans of a pricing page: the same rows in each column,
// a check for what is an advantage of the kind, a dash for what it lacks or requires
export default {
  name: "ChoosePlatform",
  data() {
    return {
      categories: ["arbitrage", "site", "landing"],
      // platform.choose.rows.<row> is the label, platform.choose.<kind>.<row> the value
      rows: ["launch", "setup", "server", "ssl", "formats", "base", "payouts", "verification"],
      pros: {
        arbitrage: ["launch", "setup", "server", "ssl", "verification"],
        site: ["setup", "formats", "base", "payouts"],
        landing: ["setup", "formats", "base"],
      },
    };
  },
};
</script>
<style lang="scss" scoped>
// The columns share the rows of one grid (subgrid), so a row lines up across the three columns
.kinds {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 20px;
  row-gap: 20px;
  margin-bottom: 24px;

  @media (max-width: 991px) {
    grid-template-columns: minmax(0, 1fr);
  }
}

.kind {
  display: grid;
  grid-template-rows: subgrid;
  row-gap: 0;
  padding: 25px 30px;

  @media (max-width: 767px) {
    padding: 25px 20px;
  }

  &__head {
    padding-bottom: 16px;

    h2 {
      margin-bottom: 6px;
    }

    p {
      margin: 0;
      font-size: 14px;
      line-height: 1.4;
      color: #828289;
    }
  }

  &__row {
    padding: 12px 0;
    border-top: 1px solid rgba(130, 130, 137, 0.2);
  }

  &__label {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    color: #828289;
  }

  &__value {
    display: flex;
    align-items: flex-start;
    column-gap: 10px;
    font-size: 14px;
    line-height: 1.4;

    svg {
      flex-shrink: 0;
      width: 16px;
      height: 16px;
      margin-top: 1px;
      fill: #37807d;
    }
  }

  &__dash {
    flex-shrink: 0;
    width: 16px;
    text-align: center;
    color: #828289;
  }

  &__action {
    align-self: end;
    padding-top: 20px;
  }
}
</style>
